import {HTTP} from "../core/http/http-common";
import VueCookies from 'vue-cookies'
const guidGenerator = () => {  
  let S4 = function () {
      return Math.random().toString(36).substring(2, 11);
  };
  return '_' + S4() + S4() + S4() + S4();
}
export const SendAccess = async (sessionId,action) => {
    return await HTTP.post(`${"/stat/acces_send"}`, { "EmpStatsQuery" :{ "session_id":sessionId ,"action":action }});
};

export const acces_send = (action) =>{
  let currentDate = new Date();
  let expireDate = new Date(currentDate.getTime() + (20 * 60 * 1000));
  let sessionId = VueCookies.get('session_acces'); 
  if(sessionId)
  {SendAccess(sessionId,action)
  }
  else
{ sessionId = guidGenerator();
  VueCookies.set('session_acces', sessionId, { expires: expireDate })
  SendAccess(sessionId, action)
}
}



// WEBPACK FOOTER //
// ./src/service/access_service.js